// extracted by mini-css-extract-plugin
export default {"TabbedContainer":"Z2OhdoFY","TabPanel":"H9OXdLII"};